import { axiosInstance } from ".."

const sitesList = async (query) => {
  return new Promise(async (resolve, reject) => {
    axiosInstance
      .get(`internal/ConstructionSite?${query}`)
      .then((res) => {
        if (res.status === 200) {
          return resolve(res);
        }
        return resolve(res);
      })
      .catch((err) => {
        return reject(err);
      });
  });
};

export default sitesList;